import PropTypes from "prop-types";
import { useEffect } from "react";
import {
  concatenateQueryParams,
  isLocalURL,
} from "@gonoodle/gn-universe-utils";

import BugsnagClient from "../utils/bugsnag";
import Link from "./Link";

export default function ExternalLink({ children, href, linkParams, ...rest }) {
  useEffect(() => {
    if (isLocalURL(href)) {
      BugsnagClient.notify(
        new Error(`ExternalLink have invalid href: ${href}`),
      );
    }
  }, [href]);
  return (
    <Link
      href={concatenateQueryParams("/external-link-disclaimer", {
        ...linkParams,
        href,
      })}
      {...rest}
    >
      {children}
    </Link>
  );
}

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  passHref: PropTypes.bool,
  replace: PropTypes.bool,
  scroll: PropTypes.bool,
  shallow: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      properties: PropTypes.shape({}).isRequired,
    }),
  ),
  linkParams: PropTypes.shape({
    sourceId: PropTypes.string,
    sourceName: PropTypes.string,
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
    sourceElement: PropTypes.string,
  }),
};

ExternalLink.defaultProps = {
  as: undefined,
  passHref: false,
  replace: false,
  scroll: true,
  shallow: false,
  events: [],
  className: undefined,
  linkParams: undefined,
};
